module.exports = __webpack_public_path__ + "img/user-avatar.115c7f76.png";